window.fit = window.fit || {};

(function($) {

  fit.personalContentWizard = function(root) {
    root.find('.js-personal-content-wizard-tab').click(function() {
      if ($(this).hasClass('is-selected')) {
        return false
      }
      else {
        root.find('.is-selected').removeClass('is-selected');
        root.find('.is-visible').removeClass('is-visible');
        $(this).addClass('is-selected')
        root.find('.js-personal-content-wizard-content').eq($(this).index()).addClass('is-visible');
      }
    });
  };

  $('.js-personal-content-wizard').each(function() {
    new fit.personalContentWizard($(this));
  })

})(jQuery);
